import { render, staticRenderFns } from "./DetailUser.vue?vue&type=template&id=9c4431be&scoped=true"
import script from "./DetailUser.vue?vue&type=script&lang=js"
export * from "./DetailUser.vue?vue&type=script&lang=js"
import style0 from "./DetailUser.vue?vue&type=style&index=0&id=9c4431be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4431be",
  null
  
)

export default component.exports